import { c as _c } from "react/compiler-runtime";
import { SkeletonBar } from '@petsmart-ui/sparky';
export function MiniPdpSkeleton() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SkeletonBar className="mini-pdp-drawer__loading-image" data-testid="mini-pdp-loading-image" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mini-pdp-drawer__product-info">{t0}<div className="mini-pdp-drawer__product-content"><SkeletonBar className="mini-pdp-drawer__loading-name" data-testid="mini-pdp-loading-name" /><SkeletonBar className="mini-pdp-drawer__loading-price" data-testid="mini-pdp-loading-price" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mini-pdp-drawer__loading-variants"><SkeletonBar className="mini-pdp-drawer__loading-variant-label" data-testid="mini-pdp-loading-variant-label" /><SkeletonBar className="mini-pdp-drawer__loading-variant-row" data-testid="mini-pdp-loading-variant-row" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="mini-pdp-drawer__loading-skeleton" data-testid="mini-pdp-loading-skeleton" aria-hidden="true">{t1}{t2}<div className="delivery-options mini-pdp-drawer__loading-fulfillment">{Array.from({
          length: 3
        }, _temp)}</div><SkeletonBar className="mini-pdp-drawer__loading-add-to-cart" data-testid="mini-pdp-loading-add-to-cart" /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function _temp(_, index) {
  return <SkeletonBar key={index} className="mini-pdp-drawer__loading-fulfillment-tile" data-testid="mini-pdp-loading-fulfillment" />;
}